import { isRelativeUrl } from './utils/urlUtils';

// Default empty array for backward compatibility
export const DEFAULT_ALLOWED_HOSTNAMES: string[] = [];

/**
 * Check if a URL/path string is an external link
 *
 * External links are any that would take the user away from their current domain,
 * with relative paths considered internal, but any other domain (including
 * other veeqo.com subdomains like help.veeqo.com) considered external.
 *
 * @param {string} urlOrPath - URL or path to check
 * @param {string[]} allowedHostnames - Optional list of allowed hostnames to consider as internal
 * @returns {boolean} Whether the URL is external
 */
export function isExternalLink(
  urlOrPath: string,
  allowedHostnames: string[] = DEFAULT_ALLOWED_HOSTNAMES,
): boolean {
  if (isRelativeUrl(urlOrPath)) return false;

  // For protocol-relative URLs, prepend 'http:' to properly parse
  const { hostname } = new URL(urlOrPath.startsWith('//') ? `http:${urlOrPath}` : urlOrPath);

  const requestHostname = hostname.toLowerCase();
  const currentHostname = window.location?.hostname?.toLowerCase?.() || '';

  // Check if hostname is in the allowed list
  if (
    allowedHostnames.length > 0 &&
    allowedHostnames.some((allowed) => allowed.toLowerCase() === requestHostname)
  ) {
    return false;
  }

  // Only treat as internal if it's the exact same hostname as current
  return requestHostname !== currentHostname;
}
